import { render, staticRenderFns } from "./LegacyChartReferralAge.vue?vue&type=template&id=f0a5909a&"
import script from "./LegacyChartReferralAge.vue?vue&type=script&lang=ts&"
export * from "./LegacyChartReferralAge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports